<template>
  <div class="content-table">
    <!-- <div class="content-row title_row">
      首页>优惠合同
    </div> -->
    <div class="content-row" style="margin-bottom:0">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/HomePage/index' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>优惠合同</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="content-row title_row" style="margin-top: 2%;margin-bottom: 2%;">
      <div style="display: inline-block;">
        <img src="/index/static/image/hongxian.png" align="absmiddle" />
        <label class="title_font">优惠合同</label>
      </div>
      <div style="display: inline-block;">
        <el-button class="btn back_color_one" @click="effective(1)">生效</el-button>
        <el-button class="btn back_color_two" @click="effective(0)">失效</el-button>
        <el-button class="btn back_color_three" @click="effective(2)">全部</el-button>
      </div>
    </div>
    <template>
      <el-table
        :data="data"
        height="500"
        :header-cell-style="rowStyle"
        class="content-row table_scroll"
        fixed
      >
        <el-table-column prop="agreement_code" border label="特价编号">
          <template slot-scope="scope">
            <span @click="detaile(scope.row)" style="cursor: pointer;color:rgba(78, 133, 206, 1)">{{scope.row.agreement_code}}</span>
            <!-- <el-button type="text" size="small" @click="handleOrder(scope.row)" v-if="scope.row.order_count==0">管理订单</el-button>
            <el-button type="text" size="small" @click="handleOrder(scope.row)" v-else>{{scope.row.order_count}}</el-button>-->
          </template>
        </el-table-column>
        <el-table-column prop="promo_code" border label="优惠码"></el-table-column>
        <el-table-column prop="custom_code" border label="客户代码"></el-table-column>
        <el-table-column prop="custom_name" border label="客户名称"></el-table-column>
        <el-table-column prop="begin_time" border label="生效起始日期"></el-table-column>
        <el-table-column prop="end_time" border label="生效截止日期"></el-table-column>
        <el-table-column prop="order_time" border label="单据日期"></el-table-column>
        <el-table-column prop="contact" border label="联系人"></el-table-column>
      </el-table>
    </template>
  </div>
</template>
<script>
var total_row = [];
export default {
  name: "",
  components: {},

  data() {
    return {
      data: [],
      rowStyle: {
        color: "#fff",
        background: "#52a6ee"
      },
      total: 0,
      pagesize: 10,
      billTime: {
        show: false
      },
      detailes: "",
      row: [],
      sums: "0.00",
      discount: ""
    };
  },
  mounted() {
    this.view();
  },
  watch: {
    currentPage(oldV, newV) {
      
    },
    page: "view",
    pagesize: "view"
  },
  methods: {
    view() {
      this.$axios({
        method: "post",
        url: "/index/contract/index",
        params: {
          status: "2"
        }
      })
        .then(res => {
          this.data = res.data.data;
          
        })
        .catch(err => {
          this.$message(err);
        });
    },
    effective(value) {
      this.$axios({
        method: "post",
        url: "/index/contract/index",
        params: {
          status: value
        }
      })
        .then(res => {
          this.data = res.data.data;
          
        })
        .catch(err => {
          this.$message(err);
        });
    },
    detaile(row) {
      this.$router.push({
        path: "/Contract/detaile",
        query: {
          id: row.id
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.title_row {
  display: flex;
  justify-content: space-between;
}
.title_font {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
}
.btn {
  width: 77px;
  height: 30px;
  font-size: 14px;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 4px;
}
.back_color_one {
  background: rgba(78, 133, 206, 1);
}
.back_color_two {
  background: rgba(0, 128, 128, 1);
}
.back_color_three {
  background: rgba(219, 33, 45, 1);
}
.discount {
  width: 55%;
}
.table_scroll ::-webkit-scrollbar {
  width: 0px; /*滚动条宽度*/
  height: 5px; /*滚动条高度*/
  background-color: white;
  margin-right: 10px;
}

/*定义滑块 内阴影+圆角*/
.table_scroll ::-webkit-scrollbar-thumb {
  -webkit-box-shadow: inset 0 0 6px #f5f7fa;
  background-color: rgba(221, 222, 224); /*滚动条的背景颜色*/
}
.el-table__fixed-right-patch {
  width: 0px; /*滚动条宽度*/
}
</style>



// WEBPACK FOOTER //
// src/components/Contract/index.vue